<script>
/* COMPOSANTS */
import MultiSelect from 'primevue/multiselect';
import AkCalendar from '@components/v2/input/AkCalendar';
import AkButtonFooterSidebarFilter from '@components/v2/general/AkButtonFooterSidebarFilter.vue';

/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';
import utilsMixin from '@mixins/utilsMixin';
import sidebarMixin from '@mixins/sidebarMixin';
import accommodationTypeConst from '@mixins/const/accommodationTypeConst';
import residenceTypeConst from '@mixins/const/residenceTypeConst';
import companyMixin from '@mixins/companyMixin';
import AkAutocomplete from '@components/v2/input/AkAutocomplete.vue';
import ownerAutocompleteMixin from '@mixins/autocomplete/ownerAutocompleteMixin';
import mandatAutocompleteMixin from '@mixins/autocomplete/mandatAutocompleteMixin';
import accommodationAutocompleteMixin from '@mixins/autocomplete/accommodationAutocompleteMixin';
import mandatStatusFilterConst from '@mixins/const/mandatStatusFilterConst';

/* SERVICES */

export default {
  components: {
    AkAutocomplete,
    AkCalendar,
    MultiSelect,
    AkButtonFooterSidebarFilter,
  },
  mixins: [
    permissionsMixin,
    utilsMixin,
    ownerAutocompleteMixin,
    mandatAutocompleteMixin,
    accommodationAutocompleteMixin,
    companyMixin,
    sidebarMixin,
    accommodationTypeConst,
    mandatStatusFilterConst,
    residenceTypeConst,
  ],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      enabledStateConst: [
        {label: this.$t('account.all_third_party'), value: null},
        {label: this.$t('account.enabled_only_third_party'), value: false},
        {label: this.$t('account.disabled_only_third_party'), value: true},
      ],
    };
  },
  mounted() {},
  methods: {
    itemSelect(item) {
      this.$nextTick(() => {
        this.callback[0]();
      });
    },
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      this.$refs.accommodationAutocomplete.reset();
      this.$refs.mandatAutocomplete.reset();
      this.$refs.ownerAutocomplete.reset();
      this.callback[1]();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent>
    <MultiSelect
      v-model="currentValue.companyIds"
      :placeholder="$t('company.one')"
      :options="this.companies"
      :loading="this.loadingCompanies"
      option-label="name"
      option-value="id"
      filter
      filter-placeholder="Filtrer"
      @change="itemSelect"
      class="form-control"
      :display-label="false" />
    <AkAutocomplete
      ref="ownerAutocomplete"
      v-model="currentValue.ownerId"
      :inline="true"
      :label="$t('owner.ownerDisplay')"
      option-value="id"
      option-label="display"
      @item-select="itemSelect"
      :force-selection="false"
      :init-method="this.autocompleteOwnerById"
      :search-method="this.autocompleteOwner"
      :search-object="this.autocompleteOwnerCustomer()"
      :search-label="this.autocompleteOwnerQuery" />
    <AkAutocomplete
      ref="accommodationAutocomplete"
      v-model="currentValue.accommodationId"
      :inline="true"
      option-value="id"
      option-label="display"
      :minLengthToLaunchSearch="3"
      @item-select="itemSelect"
      :placeholder="$t('accommodation.short')"
      :search-method="this.autocompleteAccommodation"
      :search-label="this.autocompleteAccommodationQuery"
      :init-method="this.autocompleteAccommodationById" />
    <AkAutocomplete
      ref="mandatAutocomplete"
      v-model="currentValue.mandatId"
      :inline="true"
      :label="$t('mandat.details')"
      option-value="id"
      option-label="num"
      @item-select="itemSelect"
      :force-selection="false"
      :init-method="this.autocompleteMandatById"
      :search-method="this.autocompleteMandat" />
    <AkCalendar
      ref="inputSearchFrom"
      @value-change="itemSelect"
      v-model="currentValue.periodMandatStart"
      inline
      date-format="dd/mm/yy"
      selection="range"
      :placeholder="$t('period.title')" />
    <MultiSelect
      v-model="currentValue.status"
      :placeholder="$t('mandat.status')"
      :options="mandatStatusFilterConstForThirdParty"
      option-label="label"
      option-value="value"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      @change="itemSelect" />

    <AkButtonFooterSidebarFilter :validateLabel="$t('search.search')" @action="search" @reset="reset" />
  </form>
</template>
